<template>
    <a class="speech-bubble" :href="url" :style="{ top: top, left: left }" :class="`bg-${color}`">
        {{ title }}

        <span class="speech-bubble__arrow" :class="`text-${color} speech-bubble__arrow--${arrowPosition.y}-${arrowPosition.x}`">
            <svg v-show="arrowStyle === '1'" width="30px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 49 36" style="enable-background:new 0 0 49 36;" xml:space="preserve">
                <polygon points="16.8,0 0,36 49,0 "/>
            </svg>

            <svg v-show="arrowStyle === '2'" width="35px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 71.9 59.3" style="enable-background:new 0 0 71.9 59.3;" xml:space="preserve">
                <polygon points="40.5,0 0,59.3 71.9,0 "/>
            </svg>
        </span>
    </a>
</template>

<script>
export default {
    props: {
        top: {
            type: String,
            default: '0%',
        },
        left: {
            type: String,
            default: '0%',
        },
        color: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        arrowPosition: {
            default: () => {
                return {
                    x: 'left',
                    y: 'bottom'
                }
            }
        },
        arrowStyle: {
            default: '1'
        }
    }
}
</script>